// extracted by mini-css-extract-plugin
export default {"container":"Rl","overlay":"Sl","videoOverlay":"Tl","withHeader":"Ul","header":"Vl","close":"Wl","content":"Xl"};